import { useContext } from "react";
import { GlobalsContext } from "../../../../components/Context/globalsContext";

export default function LargeFirmAboutUs() {

    const { state: globalsContext } = useContext(GlobalsContext);
    const renderHtml = (htmlTag)=>{
        return {__html: htmlTag};
    }

    return(
        <>
            <div className ="grid grid-cols-1">
                        <div className="px-4">
                            <div className="px-4">
                                <div dangerouslySetInnerHTML={renderHtml(globalsContext?.globals?.aboutUs)}></div>
                            </div>
                        </div>
                    </div>
        </>
    );
}